import { render, staticRenderFns } from "./EditEvent.vue?vue&type=template&id=3f59b120&scoped=true"
import script from "./EditEvent.vue?vue&type=script&lang=js"
export * from "./EditEvent.vue?vue&type=script&lang=js"
import style0 from "./EditEvent.vue?vue&type=style&index=0&id=3f59b120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f59b120",
  null
  
)

export default component.exports